import Indicator from '../Indicator';

/** Volume-Weighted Average Price indicator */
export default class VWAPIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 */
	_getDefaultParams() {
		return {
			id: 'vwap',
			name: 'VWAP',
			description: 'The volume-weighted average price (VWAP) is a trading benchmark used by traders that gives the average price a security has traded at throughout the day, based on both volume and price. (Investopedia)  It is only available for Intraday timeframes.',
			inputs: [],
			componentSeries: [{ id: 'vwap' }]
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
